<template>
  <div>
    <v-toolbar dark flat color="secondary">
      <v-toolbar-title class="subtitle-1 font-weight-regular text-wrap text-center">
        {{ event.name }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="event.enableLobby" icon :title="$t('admin.menu.go_to_lobby')" :href="`/e/${event.slug}`">
        <v-icon>mdi-link-box-variant</v-icon>
      </v-btn>
    </v-toolbar>
    <v-list>
      <v-list-item :to="`${base}/activities`" ripple>
        <v-list-item-icon>
          <v-icon>mdi-eye-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t("admin.menu.activities") }}</v-list-item-title>
      </v-list-item>
      <v-list-item :to="`${base}/teams`" ripple>
        <v-list-item-icon>
          <v-icon>mdi-account-multiple-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t("admin.menu.teams") }}</v-list-item-title>
      </v-list-item>
      <v-list-item :to="`${base}/participants`" ripple>
        <v-list-item-icon>
          <v-icon>mdi-account-multiple-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t("admin.menu.participants") }}</v-list-item-title>
      </v-list-item>
      <v-list-item :to="`${base}/admins`" ripple v-if="$store.state.me.userRole.name === 'ADMIN'">
        <v-list-item-icon>
          <v-icon>mdi-account-multiple-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t("admin.menu.admins") }}</v-list-item-title>
      </v-list-item>
      <v-list-group value="true" no-action prepend-icon="mdi-cog-outline" disabled>
        <template v-slot:activator>
          <v-list-item-title>{{ $t("admin.menu.settings") }}</v-list-item-title>
        </template>
        <v-list-item link ripple :to="`${base}/content`">
          <v-list-item-title>{{ $t("admin.menu.content") }}</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-comment-text</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item link ripple :to="`${base}/branding`">
          <v-list-item-title>{{ $t("admin.menu.branding") }}</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-palette</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item link ripple :to="`${base}/advanced`">
          <v-list-item-title>{{ $t("admin.menu.advanced") }}</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-cogs</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <!--
      <v-list-item link ripple :to="`${base}/eventAdmins`">
        <v-list-item-title>{{
          $t("admin.menu.eventAdmins")
        }}</v-list-item-title>
        <v-list-item-icon>
          <v-icon>mdi-account-supervisor</v-icon>
        </v-list-item-icon>
      </v-list-item>
      -->
      </v-list-group>
    </v-list>
  </div>
</template>
<script>
export default {
  data() {
    return {
      event: {},
    };
  },
  async mounted() {
    this.event = await this.$axios.get(`/admin/events/${this.$route.params.eventId}`);
    this.$store.commit("EVENT", this.event);
  },
  computed: {
    base() {
      return `/admin/event/${this.$route.params.eventId}`;
    },
  },
};
</script>
